import {
  apiDocsItem,
  faqItem,
  getStartedItem,
  integrationsItem,
  launchPackItem,
  NavBarItem,
  payLinksItem,
  paymentsItem,
  rewardsItem,
  sellerDashboardItem,
  spendingLimitsItem,
} from './links';
import { useGetSellerSpendingLimitRequest } from '../../../Seller/SpendingLimitRequests/hooks/useGetSellerSpendingLimitRequest.hook';

export function NavBarLinks(isOnboarded: boolean | undefined): NavBarItem[] {
  const { spendingLimitRequests } = useGetSellerSpendingLimitRequest();

  const onboardedNavBarLinks: NavBarItem[] = [
    sellerDashboardItem,
    ...(spendingLimitRequests.length > 0 ? [spendingLimitsItem] : []),
    payLinksItem,
    paymentsItem,
    integrationsItem,
    apiDocsItem,
  ];

  const notOnboardedNavBarLinks: NavBarItem[] = [getStartedItem].concat(
    onboardedNavBarLinks,
  );

  const navBarLinks = isOnboarded
    ? onboardedNavBarLinks
    : notOnboardedNavBarLinks;

  return navBarLinks;
}

export function getResourcesLinks(isOnboarded?: boolean): NavBarItem[] {
  const onboardedResourcesLinks: NavBarItem[] = [
    launchPackItem,
    faqItem,
    rewardsItem,
  ];

  const notOnboardedResourcesLinks: NavBarItem[] = [faqItem];

  const resourcesLinks = isOnboarded
    ? onboardedResourcesLinks
    : notOnboardedResourcesLinks;

  return resourcesLinks;
}
